export const API_HOST = 'https://api.ochre.io/v1'
export const API_WP_HOST = 'https://backend.planisphere.eu/wp-json/wp/v2'
// export const API_WP_HOST = 'http://localhost:81/planisphereApi/wp-json/wp/v2'
export const API_ACF_HOST = 'https://backend.planisphere.eu/wp-json/acf/v3'
// export const API_ACF_HOST = 'http://localhost:81/planisphereApi/wp-json/acf/v3'
export const AUTH_HOST = 'https://staging.tino.agency/planisphere-api/'
export const PAYMENT_HOST = 'https://staging.tino.agency/planisphere-api/payment'